<template>
  <!-- BEGIN: Content-->
  <div class="app-content content ">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <Breadcrumb name="App Settings" :breadcrumb="breadcrumb"/>
        </div>
        <div
            class="content-header-right text-md-right col-md-3 col-12 d-md-block d-none"
        >
        </div>
      </div>
      <div class="content-body">
        <!-- account setting page -->
        <section id="page-account-settings">
          <div class="row">
            <!-- left menu section -->
            <div class="col-md-3 mb-2 mb-md-0">
              <ul class="nav nav-pills flex-column nav-left">
                <!-- general -->
                <li class="nav-item">
                  <a class="nav-link active" id="account-pill-general" data-toggle="pill" href="#account-vertical-general" aria-expanded="true">
<!--                    <i data-feather="lock" class="font-medium-3 mr-1"></i>-->
                    <BIconLock class="font-medium-3 font-weight-bold" />
                    <span class="font-weight-bold">Api Keys</span>
                  </a>
                </li>
                <li class="nav-item">
                  <a v-if="!isLoggedInByAdmin()" class="nav-link" id="account-pill-password" data-toggle="pill" href="#account-vertical-password" aria-expanded="false">
<!--                    <i data-feather="bell" class="font-medium-3 mr-1"></i>-->
                    <BIconBell class="font-medium-3 font-weight-bold" />
                    <span class="font-weight-bold">Notification</span>
                  </a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" id="account-pill-password" data-toggle="pill" href="#webhookSettings" aria-expanded="false">
                    <BIconLink class="font-medium-3 font-weight-bold" />
                    <span class="font-weight-bold">POS Webhook Settings</span>
                  </a>
                </li>
              </ul>
            </div>
            <!--/ left menu section -->

            <!-- right content section -->
            <div class="col-md-9">
              <div class="card">
                <div class="card-body">
                  <div class="tab-content">
                    <!-- general tab -->
                    <div role="tabpanel" class="tab-pane active" id="account-vertical-general" aria-labelledby="account-pill-general" aria-expanded="true">
                      <!-- header media -->
                      <div class="media">
                        <h2>API Keys</h2>
                      </div>
                      <!--/ header media -->

                      <!-- form -->
<!--                      <form class="validate-form mt-2">-->
                        <Form class="form form-horizontal" ref="settings_form" v-slot="{ meta,errors  }" @submit="sendCall" :initial-values="{clientId: clientId,clientSecret:clientSecret}">
                        <div class="row">
                          <div class="col-8">
                            <div class="form-group">
                              <label>Client ID</label>
                              <Field
                                  class="form-control"
                                  type="text"
                                  name="clientId"
                                  rules="required"
                                  :class="(errors.amount && !meta.valid && meta.touched)? 'is-invalid': ''"
                                  disabled
                              >
                              </Field>
                            </div>
                          </div>
                          <div class="col-2">
                            <label></label>
                            <div class="form-group">
<!--                                <button type="button" class="btn btn-icon btn-outline-primary" @click="copyText('clientId')">-->
<!--                                  <BIconJournalText class="text-primary" /> Copy</button>-->
                              <div class="badge badge-glow badge-pill badge-warning btn mt-1" @click="copyText(clientId)"><BIconJournalText  class="" /> Copy!</div>
                            </div>
                          </div>
                          <div class="col-8">
                            <div class="form-group">
                              <label>Client Secret</label>
                              <Field
                                  class="form-control"
                                  type="text"
                                  name="clientSecret"
                                  rules="required"
                                  :class="(errors.amount && !meta.valid && meta.touched)? 'is-invalid': ''"
                                  disabled
                              >
                              </Field>
                            </div>
                          </div>
                          <div class="col-2">
                            <label></label>
                            <div class="form-group">
                              <div class="form-group">
                                <div class="badge badge-glow badge-pill badge-warning btn mt-1" @click="copyText(clientSecret)"><BIconJournalText class="" /> Copy!</div>
                              </div>
                            </div>
                          </div>
                          <div class="col-8">
<!--                            <label class="mb-50">IP Check</label>-->
<!--                            <div class="form-group">-->
<!--                              <div class="custom-control custom-control-info custom-switch">-->
<!--                                <input type="checkbox" checked="" class="custom-control-input" id="customSwitch8" v-model="ip_check">-->
<!--                                <label class="custom-control-label" for="customSwitch8"></label>-->
<!--                              </div>-->
<!--                            </div>-->
                            <label class="mb-50">IP Check</label>
                            <div class="form-group">
                              <BIconCheckCircleFill v-if="ip_check" width="32" height="32" class="text-success" />
                              <BIconXCircleFill v-else width="32" height="32" class="text-danger" />
                            </div>
                          </div>
                          <div class="col-12 mt-1">
                            <!-- profile connection header -->
                            <div class="d-flex align-items-center mb-3">
                              <BIconStickies width="32" height="32" class="text-primary" />
                              <h4 class="mb-0 ml-75">Whitelist IPs</h4>
                            </div>

                            <div class="row">
                              <div class="col-12 col-sm-6" v-for="(item,index) in whiteListIps" :key="index">
                                <div class="form-group">
                                  <label>IP#{{index+1}}</label>
                                  <input type="text" class="form-control" id="account-username" disabled  :value="item" />
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="col-12">
<!--                            <button type="submit" class="btn btn-primary mt-2 mr-1">Save changes</button>-->
<!--                            <button type="reset" class="btn btn-outline-secondary mt-2">Cancel</button>-->
                            <button type="button" class="btn btn-gradient-danger mt-2 float-right" @click="showRevokeConfirmationModal = true">Revoke Access</button>
                          </div>
                        </div>
                      </form>
                      <!--/ form -->

                    </div>

                    <div v-if="!isLoggedInByAdmin()" class="tab-pane fade" id="account-vertical-password" role="tabpanel" aria-labelledby="account-pill-password" aria-expanded="false">
                      <!-- form -->
                      <div class="media mb-2">
                        <h2>Notification Settings</h2>
                      </div>
                      <form class="validate-form">
                        <div class="row">
                          <div class="col-12 col-sm-6">
                            <div class="form-group">
                              <label for="account-old-password">Email Address</label>
                              <div class="input-group form-password-toggle input-group-merge">
                                <input type="email" class="form-control" id="account-old-password" v-model="merchantEmail" name="email" placeholder="Email Address"  />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-12 col-sm-6">
                            <div class="form-group">
                              <label for="account-phone">Phone Number</label>
                              <div class="input-group form-password-toggle input-group-merge">
                                <input type="text" class="form-control" id="account-phone" v-model="merchantPhone" name="phone" placeholder="Phone Number" />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row mt-1">
                          <div class="col-12 col-sm-6">
                            <div class="form-group">
                              <div class="custom-control custom-switch mb-1">
                                <input  id="smsStatus" type="checkbox"
                                       class="custom-control-input" v-model="smsStatus"/>
                                <label class="custom-control-label"
                                       for="smsStatus">
                                  Sms Notification
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row mt-1">
                          <div class="col-12 col-sm-6">
                            <div class="form-group">
                              <div class="custom-control custom-switch mb-1">
                                <input  id="emailStatus" type="checkbox"
                                       class="custom-control-input" v-model="emailStatus"/>
                                <label class="custom-control-label"
                                       for="emailStatus">
                                  Email Notification
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row mt-1">
                          <div class="col-12 justify-content-end d-flex">
                            <Button class="btn btn-primary mr-1 mt-1" :loading="loader" @click="updateNotiSettings">Save Settings</Button>
                          </div>
                        </div>
                      </form>
                      <!--/ form -->
                    </div>

                    <div class="tab-pane fade" id="webhookSettings" role="tabpanel" aria-labelledby="account-pill-password" aria-expanded="false">
                      <div class="media mb-2">
                        <h2>Webhook Settings</h2>
                      </div>
                      <Form class="validate-form" v-slot="{ validate: validateForm2, values: form2Values }" ref="form2">
                        <div class="row">
                          <div class="col-12 col-sm-8">
                              <label for="account-e-mail">URL</label>
                              <Field
                                  v-model="webhookUrl"
                                  type="url"
                                  rules="url-custom2|max:255"
                                  name="webhookUrl"
                                  class="form-control"
                                  placeholder="Enter Webhook URL"
                              />
                              <ErrorMessage name="webhookUrl" class="text-danger" />
                          </div>
                        </div>
                        <div class="row ">
                          <div class="col-12">
                            <Button type="button" class="btn btn-primary mt-1 btn-sm" :loading="loader" @click="() => updateWebhookSettings(false)">Save</Button>
                            <Button v-if="webhookUrlInApi" type="button" class="btn btn-danger ml-1 mt-1 btn-sm" :loading="deleteLoader" @click="showConfirmationModal = true">Remove</Button>
                          </div>
                        </div>
                      </Form>
                      <div class="row mt-3 ">
                        <div class="col-12">
                          <div class="card bg-light border">
                            <div class="card-body">
                              <div class="mb-1">
                                <div class="alert alert-warning" role="alert">
                                  <div class="alert-body text-center">Webhook Details: <strong>This Webhook is for POS transactions only.</strong></div>
                                </div>
                              </div>
                              <h5 class="mb-2 ">Payload (POST body)</h5>
                              <p class="mb-1 font-weight-bold">Common fields (all transaction types)</p>
                              <ul class="mb-2">
                                <li>storeId</li>
                                <li>terminalId</li>
                                <li>channelId</li>
                                <li>posId</li>
                                <li>transactionType (e.g., SALE, PRE_AUTH, CAPTURE, REFUND, VOID)</li>
                                <li>transactionStatus (e.g., CREATED, AUTHORIZED, CAPTURED, REFUNDED, VOIDED, FAILED)</li>
                                <li>transactionId</li>
                                <li>feesAmount → { "value": &lt;number&gt;, "currency": "AED" }</li>
                                <li>vatAmount → { "value": &lt;number&gt;, "currency": "AED" }</li>
                                <li>transactionAmount → { "value": &lt;number&gt;, "currency": "AED" }</li>
                                <li>card → { "brand": "visa" | "mastercard" | "...", "last4": "4242" }</li>
                                <li>channelName</li>
                                <li>hostReferenceNumber</li>
                                <li>storeName</li>
                                <li>transactionTime</li>
                              </ul>

                              <p class="mb-1 font-weight-bold">Refund-specific fields</p>
                              <ul class="mb-2">
                                <li>refundAmount → { "value": &lt;number&gt;, "currency": "AED" }</li>
                                <li>remainingAmountFromOriginalTx → { "value": &lt;number&gt;, "currency": "AED" }</li>
                              </ul>

                              <p class="mb-1 font-weight-bold">Capture-specific fields</p>
                              <ul class="mb-2">
                                <li>captureAmount → { "value": &lt;number&gt;, "currency": "AED" }</li>
                                <li>originalAmount → { "value": &lt;number&gt;, "currency": "AED" }</li>
                              </ul>

                              <h6 class="mt-3">Example JSON</h6>
                              <pre class="bg-dark text-white p-2 rounded small">
{
  "eventId": "evt_8f3c2a",
  "transactionId": "tx_abc123",
  "transactionType": "CAPTURE",
  "transactionStatus": "CAPTURED",
  "storeId": "store_001",
  "terminalId": "term_123",
  "channelId": "ecom",
  "posId": "pos_45",
  "feesAmount": { "value": 150, "currency": "AED" },
  "vatAmount": { "value": 50, "currency": "AED" },
  "transactionAmount": { "value": 10000, "currency": "AED" },
  "card": { "brand": "visa", "bin-number": "4242" },
  "channelName": "Online Store",
  "hostReferenceNumber": "HREF123456789",
  "storeName": "Main Retail Store",
  "transactionTime": "2025-09-12T05:30:42Z",
  "captureAmount": { "value": 10000, "currency": "AED" },
  "originalAmount": { "value": 10000, "currency": "AED" }
}
        </pre>
                            </div>
                          </div>
                        </div>
                      </div>

                    </div>


                  </div>
                </div>
              </div>
            </div>
            <!--/ right content section -->
          </div>
        </section>
        <!-- / account setting page -->

      </div>
    </div>
  </div>
  <!-- END: Content-->
  <RevokeConfirmationModal :show="showRevokeConfirmationModal" @revoke="revokeAccess"
          @hide="showRevokeConfirmationModal = false"></RevokeConfirmationModal>

  <ConfirmationModal :show="showConfirmationModal" @confirm="() => updateWebhookSettings(true)" message="Are you sure to remove webhook?"
                     title="Remove Webhook"
                     :image="`${publicPath}images/confirm.png`" @hide="showConfirmationModal = false"></ConfirmationModal>

</template>

<script>
import {useToast} from "vue-toastification";
import ToastificationContent from "@/components/common/ToastificationContent.vue";
export default {
  mounted() {
    this.getMerchantAppSettings()
  },
  data() {
    return {
      breadcrumb: [
        {name: 'App'},
        {name: 'Settings'},
      ],
      loader: false,
      clientSecret: '',
      clientId:'',
      toastG : useToast(),
      showRevokeConfirmationModal: false,
      ip_check:false,
      whiteListIps: [],
      merchantEmail:this.$store.getters.getLoggedInUser ? this.$store.getters.getLoggedInUser.email : '',
      merchantPhone:this.$store.getters.getLoggedInUser ? this.$store.getters.getLoggedInUser.phone_number : '',
      smsStatus:true,
      emailStatus:true,
      webhookUrl:'',
      webhookUrlInApi:false,
      deleteLoader:false,
      showConfirmationModal:false,

    }
  },
  methods: {
    revokeAccess(){
      this.makeRequest('post', 'v1/update-merchant-app-credentials', {}).then(callResponse => {

        if (!callResponse.error) {
          let code = callResponse.response.data.code;

          if (code == 200) {
            let data = callResponse.response.data.data
            this.showRevokeConfirmationModal = false
            this.clientId = data.client_id
            this.clientSecret = data.client_secret
            this.$refs.settings_form.setValues({
              clientId: data.client_id,
              clientSecret: data.client_secret,
            })
          }
        }

      });
    },
    // copyText(ref) {
    //   navigator.clipboard.writeText(this[ref]);
    //   this.toastG({
    //     component: ToastificationContent,
    //     props: {
    //       title: 'Text Copied',
    //       icon: 'BellIcon',
    //       text: this[ref],
    //       variant:'success',
    //     },
    //   })
    // },
    sendCall(){

    },
    getMerchantAppSettings() {

      this.makeRequest('post', 'v1/get-merchant-app-settings', {},{},false).then(callResponse => {

        this.loader = false
        if (!callResponse.error) {
          let code = callResponse.response.data.code;

          if (code == 200) {
            let data = callResponse.response.data.data
            if(typeof(data[0]) != 'undefined'){
              this.clientId = data[0].client_id
              this.clientSecret = data[0].client_secret
              this.ip_check = data[0].is_ip_check ? true : false
              this.whiteListIps = data[0].allowed_ips
              this.webhookUrl = data[0].webhook_url
              if(this.webhookUrl && this.webhookUrl != ''){
                this.webhookUrlInApi = true
              }
            }
          }
        }

        this.getMerchantNotiSettings()

      });

    },
    updateNotiSettings(){
      this.loader = true
      let data = {
        email:this.merchantEmail,
        phoneNumber:this.merchantPhone,
        smsStatus:this.smsStatus?1:0,
        emailStatus:this.emailStatus?1:0,
      }

      this.makeRequest('post', 'v1/update-notification-settings', data).then(callResponse => {

        this.loader = false
      })
    },
    async updateWebhookSettings(forDelete = false) {
      let data = {
        type:"webhook",
        webhookUrl:this.webhookUrl,
      }

      if(forDelete){
        this.webhookUrl = ''
        data.webhookUrl = ''
        data.type = 'removeWebHook'
        this.deleteLoader = true

        this.makeRequest('post', 'v1/update-merchant-app-settings', data).then(callResponse => {
          this.deleteLoader = false
          this.showConfirmationModal = false
        })

        return
      }

      if (!this.webhookUrl || this.webhookUrl.trim() === '') {


        this.toastG({
          component: ToastificationContent,
          props: {
            title: 'Webhook URL is required',
            icon: 'BellIcon',
            text: 'Please enter a valid URL before saving.',
            variant: 'danger',
          },

        }, {toastClassName: 'badge-glow badge-danger'})

        return
      }

      const form2 = this.$refs.form2;
      const form2Result = await form2.validate();


      if (form2Result.valid) {
        this.loader = true

        this.makeRequest('post', 'v1/update-merchant-app-settings', data).then(callResponse => {

          this.loader = false
        })
      }
    },
    getMerchantNotiSettings(){
      this.makeRequest('post', 'v1/get-user-data', {}, {}, false,false).then(callResponse => {

        if (!callResponse.error) {
          let code = callResponse.response.data.code;

          if (code == 200) {
            let data = callResponse.response.data.data
            if(data){
              if(data.details){
                let details = data.details
                if(details.notification_settings){
                  let notificationSettings = details.notification_settings
                  this.merchantEmail = notificationSettings.email? notificationSettings.email : this.merchantEmail
                  this.merchantPhone = notificationSettings.phoneNumber? notificationSettings.phoneNumber : this.merchantPhone


                  this.smsStatus = notificationSettings.smsStatus == 0? false : true
                  this.emailStatus = notificationSettings.emailStatus == 0 ? false : true
                }
              }
            }

          }

        }
      })
    },
  },
}
</script>

